import { createSlice } from '@reduxjs/toolkit';
import { addNewVehicle, editInvoiceVehicle } from './vehicleInvoiceService';

const initialState = {
  newVehicle: {
    isVehicleCreating: null,
    isVehicleCreated: null,
    vehicleCreationMsg: null,
  },
   updateVehicle: {
    isVehicleUpdating: null,
    isVehicleUpdated: null,
    vehicleUpdateMsg: null,
  },
};

const vehicleInvoiceSlice = createSlice({
  name: 'vehicleInvoice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //Vehicle creating
    builder
      .addCase(addNewVehicle.pending, (state) => {
        state.newVehicle = {
          ...initialState.newVehicle,
          isVehicleCreating: true,
          vehicleCreationMsg: 'Loading',
        };
      })
      .addCase(addNewVehicle.rejected, (state, action) => {
        state.newVehicle = {
          ...initialState.newVehicle,
          isVehicleCreating: false,
          isVehicleCreated: false,
          vehicleCreationMsg: action.payload || 'Error occurred while creating the vehicle.',
        };
      })
      .addCase(addNewVehicle.fulfilled, (state, action) => {
        state.newVehicle = {
          ...initialState.newVehicle,
          isVehicleCreating: false,
          isVehicleCreated: true,
          vehicleCreationMsg: action.payload || 'Successfully created the vehicle.',
        };
      });

      // vehicle update
       builder
      .addCase(editInvoiceVehicle.pending, (state) => {
        state.updateVehicle = {
          ...initialState.updateVehicle,
          isVehicleUpdating: true,
          vehicleUpdateMsg: 'Loading',
        };
      })
      .addCase(editInvoiceVehicle.rejected, (state, action) => {
        state.updateVehicle = {
          ...initialState.updateVehicle,
          isVehicleUpdating: false,
          isVehicleUpdated: false,
          vehicleUpdateMsg: action.payload || 'Error occurred while updating the vehicle.',
        };
      })
      .addCase(editInvoiceVehicle.fulfilled, (state, action) => {
        state.updateVehicle = {
          ...initialState.updateVehicle,
          isVehicleUpdating: false,
          isVehicleUpdated: true,
          vehicleUpdateMsg: action.payload || 'Successfully updated the vehicle.',
        };
      });
  },
});

export default vehicleInvoiceSlice.reducer;
